import React from "react";
import { exchanges, contact } from "../../mock";
import { SectionHeading } from "../SectionHeading";
import Reveal from "../Reveal";
import { User, KeyRound, ArrowRight, Gift, Percent } from "lucide-react";

const Exchanges = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <SectionHeading
          eyebrow="Live Platforms"
          title="Our"
          highlight="Exchanges"
          subtitle="Play on India's top sports exchange platforms with demo access. Get your own online cricket id on any panel below."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {exchanges.map((ex, i) => (
            <Reveal key={ex.name} delay={i * 80}>
              <div className="card-neon rounded-2xl p-6 h-full flex flex-col">
                <div className="h-16 flex items-center justify-center mb-4 bg-[#0a0a13] rounded-xl">
                  <img src={ex.logo} alt={ex.name} className="max-h-12 max-w-[80%] object-contain" />
                </div>
                <h3 className="font-display font-bold text-center text-[#00e5ff] text-glow-cyan mb-4">
                  {ex.name}
                </h3>
                <div className="space-y-2 text-sm mb-4">
                  <div className="flex items-center gap-2 text-gray-300">
                    <Gift size={15} className="text-[#00ff87]" /> {ex.bonus}
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <Percent size={15} className="text-[#00ff87]" /> {ex.commission}
                  </div>
                </div>
                <div className="rounded-lg bg-[#12131f] p-3 space-y-2 text-sm mb-4">
                  <div className="flex items-center gap-2 text-gray-400">
                    <User size={14} className="text-[#00e5ff]" /> User: <span className="text-white font-medium">{ex.user}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-400">
                    <KeyRound size={14} className="text-[#00e5ff]" /> Pass: <span className="text-white font-medium">{ex.pass}</span>
                  </div>
                </div>
                <a
                  href={contact.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-auto inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-[#00ff87]/40 text-[#00ff87] text-sm font-semibold hover:bg-[#00ff87] hover:text-black transition-colors"
                >
                  Get ID <ArrowRight size={16} />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Exchanges;
